import { render } from "./Videos.vue?vue&type=template&id=2b301a4d&scoped=true&lang=pug"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=2b301a4d&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b301a4d"]])

export default __exports__